import TruckDemoIcon from "../../assets/images/demo_truck.jpg";
import valuationIcon from "../../assets/images/dollar_icon.svg";
import inspectionIcon from "../../assets/images/inspection_icon.svg";
import finderIcon from "../../assets/images/magnifier_icon.svg";
import truckIcon from "../../assets/images/truck_icon.svg";
import financeIcon from "../../assets/images/wallet_icon.svg";

export const EQUIPBID_CATEGORIES = [
  {
    name: "EquipnowLogistics",
    icon: truckIcon,
  },
  {
    name: "EquipnowFinance",
    icon: financeIcon,
  },
  {
    name: "EquipnowInspection",
    icon: inspectionIcon,
  },
  {
    name: "EquipnowValuation",
    icon: valuationIcon,
  },
  {
    name: "EquipnowFinder",
    icon: finderIcon,
  },
];

export const demoAdsListingData = [
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
  {
    image: TruckDemoIcon,
    title: "2010 Skyjack SJ8841 Aerial Scissors Lift",
    distance: "45,000 mile",
    city: "New York",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fringilla nunc in ligula malesuada.",
  },
];
